import React, { useState } from "react";
import styles from "./Checkout.module.scss";
import { useLocation, useNavigate } from "react-router-dom";
import GuestCheckoutInformation from "./guest-checkout-information-dialog/GuestCheckoutInformationDialog";
import LoginDialog from "../login-popup/LoginDialog";

type Props = {};

const Checkout: React.FC<Props> = (props: Props) => {
	const navigate = useNavigate();
	const location = useLocation();
	const [isDialogOpen, setIsDialogOpen] = useState<boolean>(false);
	const [isLoginDialogOpen, setIsLOginDialogOpen] = useState<boolean>(false); 

	const isInstallment = location.state ? location.state.isInstallment : false;

	const handleShowLoginModal = () => {
		setIsLOginDialogOpen(!isLoginDialogOpen)
	};

	const openDialog = (): void => {
		setIsDialogOpen(true);
	};

	const closeDialog = (): void => {
		setIsDialogOpen(false);
	};

	return (
		<div className={styles.container}>
			<div className={styles.banner}></div>
			<div className={styles.content}>
				{!isInstallment ? (
					<>
						<div className={styles.option}>
							<div className={styles.titleContainer}>
								<h2 className={styles.title}>Guest Checkout</h2>
								<p className={styles.description}>Proceed to checkout with your shipping Details, You can optionally sign up or sign in later</p>
							</div>
							<button className={`standardButton ${styles.btn}`} onClick={openDialog}>Continue</button>
						</div>
						<div className={styles.option}>
							<div className={styles.titleContainer}>
								<h2 className={styles.title}>Sign in for faster Checkout</h2>
								<p className={styles.description}>Proceed to checkout with your shipping Details, You can optionally sign up or sign in later</p>
							</div>
							<button className={`standardButton ${styles.btn}`} onClick={handleShowLoginModal}>
								Continue
							</button>
						</div>
					</>
				) : (
					<div className={styles.option}>
						<div className={styles.titleContainer}>
							<h2 className={styles.title}>Sign in to buy the product</h2>
							<p className={styles.description}>Sign in to buy the product with monthly installment payment</p>
						</div>
						<button className={`standardButton ${styles.btn}`} onClick={handleShowLoginModal}>
							Continue
						</button>
					</div>
				)}
			</div>

			{isDialogOpen && <GuestCheckoutInformation onCloseDialog={closeDialog} />}
			{isLoginDialogOpen && <LoginDialog onCloseDialog={handleShowLoginModal} /> }
		</div>
	);
};

export default Checkout;
